import axios from 'axios';

const userService = {
	fetchUserInfo: id => axios.get(`api/v1/users/${id}`),
	changeUserPassword: params => axios.post(`api/v1/users/${params.id}/credentials/changePassword`, params),
	updateUser: params => axios.put(`api/v1/users/${params.id}`, params),
	fetchAllUsers: () => axios.get(`api/v1/users`),
	createUser: params => axios.post(`api/v1/users`, params),
	deleteUser: params => axios.delete(`api/v1/users`, { data: params }),
	fetchUserOverrides: params =>
		axios.get(`api/v1/users/${params.userId}/applications/${params.applicationId}/overrides`),
	createUserOverride: params =>
		axios.post(`api/v1/users/${params.userId}/applications/${params.applicationId}/overrides`, params),
	deleteUserOverride: params =>
		axios.delete(`api/v1/users/${params.userId}/applications/${params.applicationId}/overrides/${params.policyId}`),
	fetchUserRoles: params => axios.get(`api/v1/users/${params.userId}/applications/${params.applicationId}/roles`),
	createUserRole: params =>
		axios.post(`api/v1/users/${params.userId}/applications/${params.applicationId}/roles`, params),
	removeUserRole: params =>
		axios.delete(`api/v1/users/${params.userId}/applications/${params.applicationId}/roles/${params.roleId}`),
	fetchUserPolicies: params =>
		axios.get(`api/v1/users/${params.userId}/applications/${params.applicationId}/policies`)
};

export default userService;
